<div class="top-elements" *ngIf="label || info">
  <label *ngIf="label">
    {{ label }}
    <span
      *ngIf="isRequired"
      [matTooltip]="'requiredInput' | translate"
      matTooltipPosition="above"
      >*</span
    >
  </label>
  <div class="top-elements__actions-container">
    <button
      class="top-elements__edit-button"
      *ngIf="isEditButton"
      (click)="editButtonPress.emit()"
      type="button"
      [matTooltip]="editButtonInfo"
    >
      <mat-icon inline>edit</mat-icon>
    </button>
    <ling-info
      *ngIf="info && !onboardingService.isActive"
      [text]="info"
    ></ling-info>
  </div>
</div>
<div class="content-and-remove-button-container">
  <div class="content-wrapper">
    <ng-content></ng-content>
  </div>
  <button
    #removeInputButton
    id="removeInputButton"
    *ngIf="removeButton"
    class="remove-button"
    type="button"
    (click)="onRemoveButtonPressed()"
  >
    <mat-icon fontIcon="remove"></mat-icon>
  </button>
</div>
<small class="error" [class.error_active]="error">
  {{ lastError }}
</small>
